import React from 'react';
import { defineMessages, T, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { NavButton } from '../nav-button';

const COPY = defineMessages({
  PLANS_AND_PRICING: {
    id: 'Pricing.plansAndPricing',
    defaultMessage: 'Plans & Pricing',
    description:
      '[Type: Label][Vis.: low] - Plans & Pricing section of nav bar',
  },
});

const Pricing = () => {
  const url = createURL('/pricing/upgrade/quickview/', {
    ut_source: 'header_loggedIn',
  });
  const title = t(COPY.PLANS_AND_PRICING);

  return (
    <>
      <Responsive minWidth="xl">
        {matches =>
          matches ? (
            <li>
              <NavButton href={url} label={title}>
                <T desc={COPY.PLANS_AND_PRICING} />
              </NavButton>
            </li>
          ) : (
            <List.Item isNavigable href={url}>
              <T desc={COPY.PLANS_AND_PRICING} />
            </List.Item>
          )
        }
      </Responsive>
    </>
  );
};

export default Pricing;
export { Pricing };
